import {motion} from "framer-motion";
import React from "react";
import {useHaptic} from "../../../Hooks/useHaptic";

export const SliderBtn = ({currentIndex, setCurrentIndex, sliderIndex, text, icon}) => {

    const { hapticFeedBack } = useHaptic("select")
    return (
        <motion.button
            whileTap={{scale: 0.95}}
            className={currentIndex === sliderIndex ? "vpn__button_slider_item btn_active" : "vpn__button_slider_item"}
            onClick={() => {
                setCurrentIndex(sliderIndex);
                hapticFeedBack();

            }}
        >
            {icon && icon}
            <p>{text}</p>
        </motion.button>
    );
};

